// export const API_URL = "https://gstsim.fabdroid.in/api/";
export const API_URL = "https://gstsim.itaaedu.com/api/";
// export const API_URL = "http://localhost:12000/api/";